import React, { useEffect, useContext, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
//import jsPDF from 'jspdf'
//import QRCode from 'qrcode'
import Skeleton from '@mui/material/Skeleton'
import { ReservationContext } from '../../context/ReservationContext'
// import { formatDate } from '../../utils/date'
import { reservationRetryRef } from '../MainTabs'

export const Complete = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  let sessionIdFromUrl = urlParams.get('session_id')
  let sessionUuidFromUrl = urlParams.get('session_uuid')
  const paymentChecked = useRef(false)

  const { paymentStatus, paymentData, checkPaymentStatus } = useContext(ReservationContext)

  const handleRetryPayment = () => {
    if (!paymentData) return
    const metadata = paymentData.metadata
    reservationRetryRef.current = {
      showId: parseInt(metadata.showId),
      scheduleId: parseInt(metadata.scheduleId),
      categories: metadata.categories,
      selectedSeats: metadata.selectedSeats.split(',').map((seat) => {
        // Parse seat identifier like "A11" into {id: "A11", row: "A", seat: 11}
        const row = seat.charAt(0)
        const seatNumber = parseInt(seat.slice(1))
        return {
          id: seat,
          row: row,
          seat: seatNumber
        }
      }),
      firstName: metadata.firstName,
      lastName: metadata.lastName,
      phone: metadata.phone,
      email: metadata.email,
      sessionUUID: metadata.sessionUUID
    }
    navigate('/retry', { replace: true })
  }

  useEffect(() => {
    if (sessionIdFromUrl) {
      navigate(window.location.pathname, { state: { sessionId: sessionIdFromUrl, sessionUuid: sessionUuidFromUrl }, replace: true })
    } else if (location.state?.sessionId) {
      // Prevent multiple concurrent checks
      if (paymentChecked.current) {
        return
      }

      paymentChecked.current = true
      checkPaymentStatus(location.state.sessionId, location.state.sessionUuid)
    } else {
      navigate('/')
    }
  }, [location, navigate, sessionIdFromUrl, sessionUuidFromUrl, checkPaymentStatus])

  async function downloadPdf(base64, filename) {
    if (!base64) return

    const dataUrl = base64.startsWith('data:') ? base64 : `data:application/pdf;base64,${base64}`

    const blob = await fetch(dataUrl).then((r) => r.blob())

    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
  }
  const generatePDF = async () => {
    await downloadPdf(paymentData.pdf_buffer, 'reservation - ClairDeScene.pdf')

    /*const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    })

    const selectedShow = shows.find((show) => show.id === parseInt(paymentData.metadata.showId))
    const selectedSchedule = selectedShow
      ? selectedShow.schedules.find((shed) => shed.id === parseInt(paymentData.metadata.scheduleId))
      : null

    // Header background - gradient effect
    doc.setFillColor(41, 128, 185) // Blue
    doc.rect(0, 0, 210, 50, 'F')

    // Title
    doc.setTextColor(255, 255, 255) // White text
    doc.setFontSize(28)
    doc.setFont('helvetica', 'bold')
    doc.text('RÉSERVATION', 20, 25)

    // Logo/Icon placeholder
    doc.setFillColor(255, 255, 255)
    doc.circle(185, 15, 8, 'F')

    // Reset text color
    doc.setTextColor(0, 0, 0)

    // QR Code
    const qrData = `Réservation ID: ${sessionIdFromUrl ?? paymentData.payment_intent_id}`
    const qrCodeDataURL = await QRCode.toDataURL(qrData)
    doc.addImage(qrCodeDataURL, 'PNG', 160, 5, 35, 35)

    let y = 60

    // Show Section
    doc.setFillColor(230, 240, 250) // Light blue background
    doc.rect(10, y - 5, 190, 40, 'F')
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(14)
    doc.setTextColor(41, 128, 185)
    doc.text('SPECTACLE', 15, y)

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(11)
    doc.setTextColor(0, 0, 0)
    y += 8
    doc.setFontSize(18)
    doc.text(`${selectedShow.title}`, 15, y)
    y += 7
    doc.setFontSize(11)
    doc.text(`Date: ${formatDate(selectedSchedule.date)} à ${selectedSchedule.time}`, 15, y)
    y += 7
    doc.text(`Lieu: ${selectedShow.location}`, 15, y)

    y += 20

    // Seats Section
    doc.setFillColor(240, 248, 235) // Light green background
    doc.rect(10, y - 5, 190, 30, 'F')
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(14)
    doc.setTextColor(34, 139, 34) // Forest green
    doc.text('PLACES', 15, y)

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(0, 0, 0)
    y += 8
    const seats = JSON.parse(paymentData.metadata.selectedSeats)
    //let seatsText = seats.map(seat => `Rang ${seat.row}, Siège ${seat.seat}`).join(' | ');
    //doc.text(seatsText, 15, y, {maxWidth: 180});
    seats.forEach((seat) => {
      doc.text(`- Rang ${seat.row}, Siège ${seat.seat}`, 15, y)
      y += 7
    })
    y += 11

    // Categories Section
    doc.setFillColor(255, 245, 220) // Beige background
    doc.rect(10, y - 5, 190, 30, 'F')
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(14)
    doc.setTextColor(184, 134, 11) // Dark goldenrod
    doc.text('CATÉGORIES', 15, y)

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(0, 0, 0)
    y += 8
    const categories = JSON.parse(paymentData.metadata.categories)
    categories.forEach((cat) => {
      if (cat.quantity > 0) {
        doc.text(`- ${cat.name}: ${cat.quantity} * ${cat.price}€`, 15, y)
        y += 5
      }
    })

    y += 8

    // Total Section
    doc.setFillColor(41, 128, 185) // Blue
    doc.rect(10, y - 5, 190, 20, 'F')
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(16)
    doc.setTextColor(255, 255, 255)
    const total = (paymentData.metadata.amount_total / 100).toFixed(2)
    doc.text(`TOTAL: ${total}€`, 100, y + 3, { align: 'right' })

    y += 25

    // Personal Info Section
    doc.setFillColor(245, 245, 245) // Light gray background
    doc.rect(10, y - 5, 190, 35, 'F')
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(12)
    doc.setTextColor(41, 128, 185)
    doc.text('INFORMATIONS PERSONNELLES', 15, y)

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(0, 0, 0)
    y += 8
    doc.text(`Nom: ${paymentData.metadata.lastName}`, 15, y)
    y += 6
    doc.text(`Prénom: ${paymentData.metadata.firstName}`, 15, y)
    y += 6
    doc.text(`Téléphone: ${paymentData.metadata.phone}`, 15, y)
    y += 6
    doc.text(`Email: ${paymentData.metadata.email}`, 15, y)

    // Footer
    y = 270
    doc.setFillColor(41, 128, 185)
    doc.rect(0, y, 210, 30, 'F')
    doc.setFont('helvetica', 'italic')
    doc.setFontSize(9)
    doc.setTextColor(255, 255, 255)
    doc.text("Merci d'avoir réservé avec nous!", 105, y + 10, { align: 'center' })
    doc.text('Réservé le ' + formatDate(Date.now(), false), 30, y + 10, { align: 'center' })
    doc.text(`Confirmation de paiement: ${paymentData.payment_intent_id || paymentData.subscription_id}`, 105, y + 18, {
      align: 'center',
      maxWidth: 170
    })

    // Download
    doc.save('reservation-ClairDeScene.pdf')*/
  }

  // Computed before hooks & early returns to satisfy Rules of Hooks
  const isSuccess = paymentData?.status === 'complete'

  if (paymentStatus === 'loading') {
    return (
      <div id='payment-status'>
        <Skeleton variant='circular' width={48} height={48} sx={{ mx: 'auto', mb: 2 }} />
        <Skeleton variant='text' width='60%' sx={{ mx: 'auto', fontSize: '1.5rem', fontWeight: 'bold' }} />
        <Skeleton variant='text' width='80%' sx={{ mx: 'auto', fontSize: '1rem' }} />
      </div>
    )
  }

  const SuccessIcon = (
    <svg width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.4695 0.232963C15.8241 0.561287 15.8454 1.1149 15.5171 1.46949L6.14206 11.5945C5.97228 11.7778 5.73221 11.8799 5.48237 11.8748C5.23253 11.8698 4.99677 11.7582 4.83452 11.5681L0.459523 6.44311C0.145767 6.07557 0.18937 5.52327 0.556912 5.20951C0.924454 4.89575 1.47676 4.93936 1.79051 5.3069L5.52658 9.68343L14.233 0.280522C14.5613 -0.0740672 15.1149 -0.0953599 15.4695 0.232963Z'
        fill='white'
      />
    </svg>
  )
  const ErrorIcon = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.25628 1.25628C1.59799 0.914573 2.15201 0.914573 2.49372 1.25628L8 6.76256L13.5063 1.25628C13.848 0.914573 14.402 0.914573 14.7437 1.25628C15.0854 1.59799 15.0854 2.15201 14.7437 2.49372L9.23744 8L14.7437 13.5063C15.0854 13.848 15.0854 14.402 14.7437 14.7437C14.402 15.0854 13.848 15.0854 13.5063 14.7437L8 9.23744L2.49372 14.7437C2.15201 15.0854 1.59799 15.0854 1.25628 14.7437C0.914573 14.402 0.914573 13.848 1.25628 13.5063L6.76256 8L1.25628 2.49372C0.914573 2.15201 0.914573 1.59799 1.25628 1.25628Z'
        fill='white'
      />
    </svg>
  )

  // The customer may have been charged: never offer to pay again from here
  if (paymentStatus === 'error') {
    return (
      <div id='payment-status'>
        <div id='status-icon' style={{ backgroundColor: '#DF1B41' }}>
          {ErrorIcon}
        </div>
        <h2 id='status-text'>Impossible de vérifier votre paiement</h2>
        <div id='details-table'>
          <table>
            <tbody>
              <tr>
                <td className='TableContent'>
                  Votre paiement a peut-être bien été effectué. Ne payez pas une seconde fois : vérifiez à nouveau dans quelques instants.
                </td>
              </tr>
              <tr>
                <td className='TableContent'>
                  <button
                    onClick={() => checkPaymentStatus(location.state?.sessionId, location.state?.sessionUuid)}
                    style={{
                      marginTop: '20px',
                      padding: '10px 20px',
                      backgroundColor: '#DF1B41',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px'
                    }}
                  >
                    Vérifier à nouveau
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  if (!paymentData) {
    return null
  }

  return (
    <div id='payment-status'>
      <div id='status-icon' style={{ backgroundColor: isSuccess ? '#30B130' : '#DF1B41' }}>
        {isSuccess ? SuccessIcon : ErrorIcon}
      </div>
      <h2 id='status-text'>{isSuccess ? 'Paiement réussi' : 'Une erreur est survenue lors du paiement, veuillez réessayer.'}</h2>
      <div id='details-table'>
        {paymentData.payment_intent_id && isSuccess && (
          <table>
            <tbody>
              <tr>
                <td className='TableLabel'>Référence de paiement:</td>
                <td id='intent-id' className='TableContent'>
                  {paymentData.payment_intent_id}
                </td>
              </tr>
              <tr>
                <td className='TableLabel'>Merci pour votre réservation!</td>
                <td id='intent-id' className='TableContent'>
                  Le PDF de votre réservation est disponible ci-dessous. Vous pouvez le télécharger et l&apos;imprimer pour le présenter à
                  l&apos;entrée du spectacle. Il vous sera également envoyé par email, à l&apos;adresse communiquée lors de la réservation
                  (vérifiez votre courrier indésirable / spams).
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button
                    onClick={generatePDF}
                    style={{
                      marginTop: '20px',
                      padding: '10px 20px',
                      backgroundColor: '#30B130',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px'
                    }}
                  >
                    Télécharger le PDF de réservation
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {!isSuccess && paymentData.metadata && (
          <table>
            <tbody>
              <tr>
                <td className='TableContent'>
                  <button
                    onClick={handleRetryPayment}
                    style={{
                      marginTop: '20px',
                      padding: '10px 20px',
                      backgroundColor: '#DF1B41',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px'
                    }}
                  >
                    Réessayer le paiement / Modifier la réservation
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
